module.exports = __webpack_public_path__ + "static/media/Logo__Deloitte.51cd84d0.svg";